import { Logo } from './Logo.tsx';

interface SlideChromeProps {
  index: number;
  total: number;
  variant?: 'navy' | 'light';
  companyName: string;
}

export function SlideChrome({ index, total, variant = 'navy', companyName }: SlideChromeProps) {
  return (
    <div className="sab-slide__chrome" aria-hidden="true">
      <Logo variant={variant} />
      <span>
        {companyName} · {String(index + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
      </span>
    </div>
  );
}
